import React, { useEffect, useRef, useCallback } from 'react';
import './TimelineTranscriptHover.css';

function TimelineTranscriptHover({ minute, transcript, position, onClose, onMouseEnter, onMouseLeave }) {
  const hoverRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (hoverRef.current && !hoverRef.current.contains(event.target)) {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  const getHoverTitle = useCallback(() => {
    return `Minute ${minute} - Transcript`;
  }, [minute]);

  const renderTranscriptItem = useCallback((item, index) => (
    <div key={index} className="transcript-item">
      <div className="transcript-item-header">
        <span className="transcript-speaker">{item.speaker}</span>
        <span className="transcript-duration">{item.displayDuration}</span>
      </div>
      <div className="transcript-item-content">
        <div className="transcript-text">{item.text}</div>
      </div>
    </div>
  ), []);

  const renderTranscriptItems = useCallback(() => {
    if (!transcript || transcript.length === 0) {
      return (
        <div className="transcript-empty">
          <p>No transcript available for this minute.</p>
        </div>
      );
    }
    
    return transcript.map((item, index) => renderTranscriptItem(item, index));
  }, [transcript, renderTranscriptItem]);

  const getHoverStyle = useCallback(() => {
    return {
      left: `${position.x}px`,
      top: `${position.y}px`,
      transform: 'translateX(-50%) translateY(-100%)'
    };
  }, [position]);

  const getHoverClass = useCallback(() => {
    return 'timeline-transcript-hover';
  }, []);

  return (
    <div 
      ref={hoverRef}
      className={getHoverClass()}
      style={getHoverStyle()}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="timeline-transcript-hover-header">
        <h4>{getHoverTitle()}</h4>
        <button 
          className="timeline-transcript-hover-close"
          onClick={onClose}
          title="Close"
        >
          <i className="ti ti-x"></i>
        </button>
      </div>
      <div className="timeline-transcript-hover-content">
        {renderTranscriptItems()}
      </div>
      <div className="timeline-transcript-hover-arrow"></div>
    </div>
  );
}

export default TimelineTranscriptHover;
